// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2_HJU","inner":"Footer_inner__5xMEN","nextIcon":"Footer_nextIcon__2Fb9W","innerLeft":"Footer_innerLeft__2cJUv"};